import { useEffect, useState } from "react";
import {
  AdminDirectory,
  EMPTY_ADMIN_DIRECTORY,
  loadAdminDirectory,
  subscribeAdminDirectory,
} from "../api/adminDirectory";
import { isAdminAccount } from "../utils/roles";

type AdminDirectoryState = {
  directory: AdminDirectory;
  isLoading: boolean;
  failed: boolean;
};

/** Données croisées des tickets admin ; vides (et jamais chargées) pour les autres comptes. */
export const useAdminDirectory = () => {
  const [state, setState] = useState<AdminDirectoryState>({
    directory: EMPTY_ADMIN_DIRECTORY,
    isLoading: isAdminAccount(),
    failed: false,
  });

  useEffect(() => {
    if (!isAdminAccount()) return;
    let alive = true;
    const update = (directory: AdminDirectory) => {
      if (alive) setState({ directory, isLoading: false, failed: false });
    };
    const unsubscribe = subscribeAdminDirectory(update);
    loadAdminDirectory()
      .then(update)
      .catch(() => {
        if (alive) setState((s) => ({ ...s, isLoading: false, failed: true }));
      });
    return () => {
      alive = false;
      unsubscribe();
    };
  }, []);

  // Les tickets abonnés reçoivent les nouvelles données via `subscribeAdminDirectory`.
  const reload = () => {
    loadAdminDirectory(true).catch(() =>
      setState((s) => ({ ...s, failed: true }))
    );
  };

  return { ...state, reload };
};
